<table class="table">
  <thead>
  <tr>
    <th>
      {{'lang.globals.name' | translate}}
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let group of mediumGroups">
    <td>
      <sb-comp-image-name-wrapper [medium]="group?.preview">
        <span firstLine>
          {{ group?.name }}
        </span>
      </sb-comp-image-name-wrapper>
    </td>
  </tr>
  </tbody>
</table>
